export default {
      id: "action-icon-subscribed-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "icons.svg#action-icon-subscribed",
      toString: function () {
        return this.url;
      }
    }